module.exports = __webpack_public_path__ + "4a964f24ed5eb9639781fef9e9b11f17.pdf";